// pages/reports/TrainingCountSummary.js
import React, { useState } from 'react';
import { Card, Button, Spinner } from 'react-bootstrap';
import ReportFilterBar from '../../components/reports/ReportFilterBar';
import useReportData from '../../hooks/useReportData';

function TrainingCountSummary() {
  const [filters, setFilters] = useState(null);
  const { data, loading, error, exportUrl } = useReportData('reports/get_training_count_summary.php', filters);

  return (
    <div className="p-2">
      <div className="d-flex justify-content-between align-items-center no-print">
        <h2>Training Count Summary</h2>
        <div>
          <Button variant="outline-secondary" className="me-2" onClick={() => window.print()} disabled={!data}>
            Print
          </Button>
          {exportUrl && (
            <Button as="a" href={exportUrl} variant="outline-primary">
              Export to CSV
            </Button>
          )}
        </div>
      </div>

      <ReportFilterBar value={filters} onChange={setFilters} showDepartmentFilter={false} />

      {error && <div className="alert alert-danger">{error}</div>}
      {loading && <Spinner animation="border" size="sm" />}

      {data && !loading && (
        <Card className="mt-2">
          <Card.Body>
            <Card.Title>Training Count Summary</Card.Title>
            <Card.Subtitle className="mb-3 text-muted">
              {data.start} to {data.end}
            </Card.Subtitle>
            <div style={{ fontSize: '3rem', fontWeight: 'bold' }}>{data.completedCount}</div>
            <div>Completed Trainings</div>
          </Card.Body>
        </Card>
      )}
    </div>
  );
}

export default TrainingCountSummary;
